import { lazy, Suspense } from 'react'
import { Navigate } from 'react-router-dom'
import { PartialRouteObject } from 'react-router'

import SidebarLayout from 'src/layouts/SidebarLayout'

import SuspenseLoader from 'src/components/SuspenseLoader'

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  )

// Dashboards

const Launchpad = Loader(lazy(() => import('src/content/dashboards/Launchpad')))
const PresaleDetails = Loader(lazy(() => import('src/content/dashboards/PresaleDetails')))
const LaunchpadManager = Loader(lazy(() => import('src/content/dashboards/ManageLaunchpad')))
const Admin = Loader(lazy(() => import('src/content/dashboards/AdminPresale')))
const Locker = Loader(lazy(() => import('src/content/dashboards/LockerDetails')))
const TermsAndConditions = Loader(lazy(() => import('src/content/dashboards/TermsAndConditions')))
const PrivacyPolicy = Loader(lazy(() => import('src/content/dashboards/PrivacyPolicy')))

export const enum PATHS {
  launchpad = 'launchpad',
  presale = 'presale',
  startLaunchpad = 'start-launchpad',
  adminLaunchpad = 'admin-launchpad',
  locker = 'locker',
  termsAndConditions = 'termsandconditions',
  privacyPolicy = 'privacypolicy'
}

const routes: PartialRouteObject[] = [
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/launchpad" replace />
      },

      {
        path: PATHS.launchpad,
        element: <Launchpad />
      },
      {
        path: `${PATHS.presale}/:pId`,
        element: <PresaleDetails />
      },
      {
        path: PATHS.startLaunchpad,
        element: <LaunchpadManager />
      },
      {
        path: `${PATHS.adminLaunchpad}/:pId`,
        element: <Admin />
      },
      {
        path: `${PATHS.locker}/:pId`,
        element: <Locker />
      },
      {
        path: PATHS.termsAndConditions,
        element: <TermsAndConditions />
      },
      {
        path: PATHS.privacyPolicy,
        element: <PrivacyPolicy />
      }
    ]
  }
]

export default routes
